/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cli_TitleInputs */

const en_hub_cli_title = /** @type {(inputs: Hub_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two commands, both directions`)
};

const id_hub_cli_title = /** @type {(inputs: Hub_Cli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua perintah, dua arah`)
};

/**
* | output |
* | --- |
* | "Two commands, both directions" |
*
* @param {Hub_Cli_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cli_title = /** @type {((inputs?: Hub_Cli_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cli_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cli_title(inputs)
	return en_hub_cli_title(inputs)
});